import React from "react";
import {
  gateNameForCode,
  getStudyGateBadgeClass,
  getStudyGateColor,
  normalizeGateCode,
} from "../../Pages/isf/isfStudyGateService";
import "./StudyGateBadge.scss";

const StudyGateBadge = ({
  code,
  label,
  className = "",
  title,
  compact = false,
  state = "",
  suffix = null,
}) => {
  const normalizedCode = normalizeGateCode(code);
  const text = String(label ?? "").trim() || gateNameForCode(normalizedCode);
  if (!text) return "—";

  const resolvedState = state === "current" || state === "done" ? state : "";
  const resolvedSuffix =
    suffix ??
    (resolvedState === "current" ? (
      <i className="fas fa-check-circle" aria-hidden="true" />
    ) : null);

  return (
    <span
      className={`${getStudyGateBadgeClass(normalizedCode)}${compact ? " is-compact" : ""}${
        resolvedState ? ` is-${resolvedState}` : ""
      } ${className}`.trim()}
      style={
        resolvedState === "done"
          ? undefined
          : { backgroundColor: getStudyGateColor(normalizedCode) }
      }
      title={title || text}
    >
      <span className="study-gate-badge__text">{text}</span>
      {resolvedSuffix ? (
        <span className="study-gate-badge__suffix" aria-hidden="true">
          {resolvedSuffix}
        </span>
      ) : null}
    </span>
  );
};

export default StudyGateBadge;
